import { DriverDocument } from "../../../models";

export const getDriverDocument = (data: any): DriverDocument => {
  return {
    id: data.id,
    category: data.category,
    label: data.label || "",
    contentType: data.content_type || "",
    createdAt: data.created_at || "",
  };
};

export const getDriverDocuments = (data: any[]): DriverDocument[] => {
  return data.map(getDriverDocument);
};
